
import { useMemo } from 'react';
import {useActiveMarker} from "../store/markerStore";
import {IDatasetBrief} from "../types/metadata";

export const useLocationAvailable = (
  panelName: string,
  datasetId: string | undefined,
  datasetBriefs: IDatasetBrief[],
  datasetIsOffline: boolean
) => {
  const activeMarker = useActiveMarker();

  return useMemo(() => {
    if (!activeMarker) return false;
    if (!datasetId) return false
    if (!activeMarker?.id) return false;

    const cell = activeMarker.waterDepth?.[panelName];
    const waterDepth = activeMarker.cellSize?.[panelName];

    const brief = datasetBriefs.find((brief: IDatasetBrief) => brief.Id === datasetId);
    const isFwe = brief?.IsFWE;

    return isFwe || (cell !== '-' && cell !== undefined && waterDepth !== '-' && waterDepth !== undefined) || datasetIsOffline;
  }, [
    activeMarker,
    panelName,
    datasetId,
    datasetBriefs,
    datasetIsOffline
  ]);
};
